import { render, staticRenderFns } from "./formulir_pencatatan_sipil.vue?vue&type=template&id=736fdc9a&"
import script from "./formulir_pencatatan_sipil.vue?vue&type=script&lang=js&"
export * from "./formulir_pencatatan_sipil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports